module.exports = __webpack_public_path__ + "img/lightbulb-05.ada3c9d7.svg";